import styled from 'styled-components';
import { Button, TableList, Loader } from '@ederzadravec/jade-ui';
import { Switch, Route } from 'react-router-dom';

import { FormTalk } from 'components';
import { useService } from 'service';
import { dbToDate } from 'utils/date';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  width: inherit;
`;

const Content = styled.div`
  width: 100%;
  margin-top: 16px;
`;

const Footer = styled.div`
  width: 100%;
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export default ({ history, location, match }) => {
  const idRoom = match?.params?.room;

  const BASE_URL = `/admin/room/details/${idRoom}/talk`;

  const [talksData, { loading }, refreshSpeakers] = useService(
    'get',
    `/room/${match.params.room}/talk`
  );

  const configList = [
    {
      name: 'Início',
      dataPath: data => dbToDate(data.startAt, 'HH:mm'),
      size: {
        md: 2,
      },
    },
    {
      name: 'Fim',
      dataPath: data => dbToDate(data.endAt, 'HH:mm'),
      size: {
        md: 2,
      },
    },
    {
      name: 'Palestra',
      dataPath: 'title.pt',
      size: {
        md: 4,
      },
    },
    {
      name: 'Palestrante',
      dataPath: 'speaker.name',
      size: {
        md: 4,
      },
    },
  ];

  const handleNewItem = () => {
    history.push(`${BASE_URL}/new`);
  };

  const handleSelectItem = item => {
    history.push(`${BASE_URL}/${item._id}`);
  };

  const handleFormClose = refresh => {
    history.push(`${BASE_URL}`);
    
    if (refresh) refreshSpeakers();
  };

  return (
    <Container>
      <Content>
        <Loader show={loading}>
          <TableList
            config={configList}
            data={talksData?.success?.talks?.data || []}
            onSelect={handleSelectItem}
          />
        </Loader>

        <Footer>
          <Button onClick={handleNewItem}>Nova Palestra</Button>
        </Footer>
      </Content>

      <Switch>
        <Route
          path={[`${BASE_URL}/new`, `${BASE_URL}/:talk`]}
          component={props => (
            <FormTalk
              {...props}
              onClose={handleFormClose}
              BASE_URL={BASE_URL}
              id_room={match?.params?.room}
            />
          )}
        />
      </Switch>
    </Container>
  );
};
